var func = {
    esRomano: function(datos){///// I
        let valor = (datos.which);
        if (valor !== 105 && valor !== 73) {
            datos.preventDefault();
        }
    },

    esLetra: function(datos){/////[A-Z] con espacio, Ñ . y -
        let valor = (datos.which);
        if(((valor < 97 || valor > 122) && (valor < 65 || valor > 90)) && (valor !== 32 && valor !== 46 && valor !== 241 && valor !== 209) && (valor !==45)){
            datos.preventDefault();
        }
    },

    esLetraOficio: function(datos){/////[A-Z] con espacio, Ñ y ., acentos
        let valor = (datos.which);
        if(((valor < 97 || valor > 122) && (valor < 65 || valor > 90)) && (valor !== 32 && valor !== 46 && valor !== 241 && valor !== 209) 
            && (valor !== 193 && valor !== 201 && valor !== 205 && valor !== 211 && valor !== 218)
            && (valor !== 225 && valor !== 233 && valor !== 237 && valor !== 243 && valor !== 250) ){
            datos.preventDefault();
        }
    },

    esNumero: function(datos){///[0-9] 
        let valor = (datos.which);
        if((valor < 48 || valor > 57)){
            datos.preventDefault();
        }
    },
    esNumeroOficio: function(datos){///[0-9] / y -
        let valor = (datos.which);
        if((valor < 47 || valor > 57) && valor !== 45){
            datos.preventDefault();
        }
    },

    esMonto: function(datos){///[0-9] sin e
        let valor = (datos.which);
        if((valor < 48 || valor > 57) && (valor !== 46)){
            datos.preventDefault();
        }
    },

    FechaDDMMAAAA: function(fecha){ //formatea datetime a DD/MM/AAAA
        fecha = String(fecha);
        return fecha.substr(8, 2) + "/" + fecha.substr(5, 2) + "/" + fecha.substr(0, 4)
    },

    FechaExcel: function(fecha){
        fecha = String(fecha);
        return fecha.substr(8, 2) + "-" + fecha.substr(5, 2) + "-" + fecha.substr(0, 4)
    },

    FechaAPalabras: function(fecha){
        var opciones = {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        };
        var nuevaFecha = new Date(fecha)
        return nuevaFecha.toLocaleString('es-ES', opciones).toUpperCase();
    },

    agregarCeros: function(monto){//agrega 00 al dinero ... 5.1 => 5.10, 5=> 5.00
        if(monto)
        return monto.toLocaleString('en-US', {minimumFractionDigits: 2})
        else if(monto == 0)
            return '0.00'
    },

    esDireccion: function(datos){/////[A-Z] con espacio, Ñ . # 0-9 y -   ASCII
        let valor = (datos.which);
        if(((valor < 97 || valor > 122) && (valor < 65 || valor > 90)) 
            && (valor !== 32 && valor !== 46 && valor !== 241 && valor !== 209) && (valor !== 35) && (valor < 48 || valor > 57) && (valor !== 45)  ){
            datos.preventDefault();
        }
    },

    esMensaje: function(datos){/////[A-Z] con espacio, Ñ . # 0-9 - , / y acentos  ASCII
        let valor = (datos.which);
        if(((valor < 97 || valor > 122) && (valor < 65 || valor > 90)) 
            && (valor !== 32 && valor !== 46 && valor !== 241 && valor !== 209) && (valor !== 35) && (valor < 48 || valor > 57) && (valor !== 45) && (valor !== 44)
            && (valor !== 47) && (valor !== 193 && valor !== 201 && valor !== 205 && valor !== 211 && valor !== 218) 
            && (valor !== 225 && valor !== 233 && valor !== 237 && valor !== 243 && valor !== 250)   ){
            datos.preventDefault();
        }
    },

    numerosAPalabras: function(numero){//numeros a palabras
        var unidades = (numero) => {
            switch(numero){
                case 1 : return 'UN'; 
                case 2 : return 'DOS';
                case 3 : return 'TRES';
                case 4 : return 'CUATRO';
                case 5 : return 'CINCO';
                case 6 : return 'SEIS';
                case 7 : return 'SIETE';
                case 8 : return 'OCHO';
                case 9 : return 'NUEVE';
            }
            return '';
        }

        var decenas = (numero) => {
            var decena = Math.floor(numero / 10)
            var unidad = numero - (decena * 10)
            switch(decena){
                case 1 : 
                    switch (unidad) {
                        case 0: return 'DIEZ';
                        case 1: return 'ONCE'; 
                        case 2: return 'DOCE'; 
                        case 3: return 'TRECE'; 
                        case 4: return 'CATORCE';  
                        case 5: return 'QUINCE';  
                        default: return 'DIECI' + unidades(unidad)
                    }
                case 2:
                    switch (unidad){
                        case 0: return 'VEINTE';
                        default: return 'VEINTI' + unidades(unidad);  
                    }
                case 3: return decenasy('TREINTA', unidad);
                case 4: return decenasy('CUARENTA', unidad);
                case 5: return decenasy('CINCUENTA', unidad);
                case 6: return decenasy('SESENTA', unidad);
                case 7: return decenasy('SETENTA', unidad);
                case 8: return decenasy('OCHENTA', unidad);
                case 9: return decenasy('NOVENTA', unidad);
                case 0: return unidades(unidad);

            }

        }

        var decenasy = (strUni, numUni)=>{
            var unidadesLetra = strUni;
            var unidadesNumero = numUni; 
            if(unidadesNumero > 0) return unidadesLetra + ' Y ' + unidades(unidadesNumero)
            return unidadesLetra;
        }

        var centenas = (numero) =>{
            var centena = Math.floor(numero / 100);
            var decena = numero - (centena * 100);

            switch(centena){
                case 1:
                    if(decena > 0) return "CIENTO " + decenas(decena);
                    return "CIEN";
                case 2: return "DOSCIENTOS " + decenas(decena);
                case 3: return "TRESCIENTOS " + decenas(decena);
                case 4: return "CUATROCIENTOS " + decenas(decena);
                case 5: return "QUINIENTOS " + decenas(decena);
                case 6: return "SEISCIENTOS " + decenas(decena);
                case 7: return "SETECIENTOS " + decenas(decena);
                case 8: return "OCHOCIENTOS " + decenas(decena);
                case 9: return "NOVECIENTOS " + decenas(decena); 

            }
            return decenas(decena);
        }
        
        var unoOMuchos = (numero, divisor, strUno, strMuchos) =>{
            var centena = Math.floor(numero / divisor)
            var residuo = numero - (centena * divisor)
            var letras = '';

            if(centena > 0)
                if(centena > 1)
                    letras = centenas(centena) + ' ' + strMuchos;
                else
                    letras = strUno;
            if(residuo > 0)
                letras += '';
            return letras;
        }

        var miles = (numero) =>{
            var divisor = 1000;
            var centena = Math.floor(numero / divisor)
            var residuo = numero - (centena * divisor)

            var strMiles = unoOMuchos(numero, divisor, /*'UN '+*/'MIL', 'MIL');
            var strCentenas = centenas(residuo);

            if(strMiles == '')
                return strCentenas;
            return strMiles + ' ' + strCentenas;
        }

        var esMillon = (numero, uno) =>{
            var strMillon = '';
            strMillon = (uno ? 'UN MILLON' : 'MILLONES');
            if(numero % 1000000 == 0)
                strMillon = strMillon + ' DE'
            return strMillon;  
        }

        var millones = (numero) =>{
            var divisor = 1000000;
            var centena = Math.floor(numero / divisor);
            var residuo = numero - (centena * divisor)

            var strMillones = unoOMuchos(numero, divisor, esMillon(numero, true), esMillon(numero, false))
            var strMiles = miles(residuo)

            if(strMillones == '')
                return strMiles
            return strMillones + ' ' + strMiles
        }
        return millones(Math.floor(numero))
    },

    primeraLetraMayuscula: function(frase){//primeras letras a mayuusculas
        return frase
                .toLowerCase()
                .split(' ')
                .map(p => p.charAt(0).toUpperCase() + p.slice(1))
                .join(' ')
    }

};

export default func;




// WEBPACK FOOTER //
// ./src/components/SIVAC/Comun/Funciones/comun.js